(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const hd = document.getElementById('hd');
  addEventListener('scroll', () => hd.classList.toggle('tuck', scrollY > 40), { passive: true });

  /* Header nav overflow.

     The row is capped at the page width, the logo can take 300px of it and
     the icons are fixed, so how much is left for the menu is a fact about the
     shop's own settings and translations - not something a breakpoint can
     know. Measure it instead, and give way in the order that costs the reader
     least:

       1. set the row tighter (smaller type, less tracking and padding);
       2. move entries off the end into a "More" panel, one at a time, until
          what remains fits.

     What it never does is shorten a label. Trailing entries go first because
     a menu is written most-important-first, which in this shop puts the
     policy and information pages - the ones the footer also carries - at the
     end. */
  (() => {
    const nav = document.querySelector('nav.main');
    if (!nav) return;

    const more = nav.querySelector('.nitem--more');
    const panel = nav.querySelector('.nmore__panel');
    if (!more || !panel) return;

    const moved = [];

    /* The nav is `min-width: 0`, so when the row runs out of room the nav box
       is narrower than its own content. That difference is the signal. */
    const fits = () => nav.scrollWidth <= nav.clientWidth + 1;

    const lastEntry = () => {
      for (let i = nav.children.length - 1; i >= 0; i--) {
        const el = nav.children[i];
        if (el !== more) return el;
      }
      return null;
    };

    const layout = () => {
      /* Always start from the full menu, or the row could only ever shed
         entries and never take them back on a wider screen. */
      while (moved.length) nav.insertBefore(moved.pop(), more);
      more.hidden = true;
      nav.classList.remove('main--tight');
      if (fits()) return;

      nav.classList.add('main--tight');
      if (fits()) return;

      more.hidden = false;
      /* The guard is for the case where even one entry plus More is too wide;
         without it a menu that can never fit would spin here. */
      let guard = nav.children.length + 2;
      while (!fits() && guard-- > 0) {
        const entry = lastEntry();
        if (!entry) break;
        panel.insertBefore(entry, panel.firstChild);
        moved.push(entry);
      }
    };

    layout();
    /* Lifts the pre-measure clip. Set after the first arrangement, never
       cleared, because from here on `layout` keeps the row fitting. */
    nav.classList.add('main--measured');

    let frame;
    addEventListener('resize', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(layout);
    }, { passive: true });

    /* Web fonts land after first paint and change every label's width, so the
       first measurement is taken against fallback metrics. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-wall"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');

    /* Whether each carousel is on screen, keyed by the element so a section the
       editor removes takes its entry with it. */
    const onScreen = new WeakMap();

    const setState = (card, playing) => {
      const button = card.querySelector('[data-ugc-toggle]');
      card.classList.toggle('ucard--playing', playing);
      if (!button) return;
      button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
    };

    const play = (card, video) => {
      /* Set as a property as well as an attribute: Safari checks the property
         when deciding whether an unprompted play is allowed. */
      video.muted = true;
      const started = video.play();
      /* A refused autoplay is not an error to swallow silently - it puts the
         poster and the play control back, so the card still offers a way in. */
      if (started && started.catch) started.catch(() => setState(card, false));
      setState(card, true);
    };

    const stop = (card, video, rewind) => {
      video.pause();
      if (rewind) video.currentTime = 0;
      setState(card, false);
    };

    /* How much of the carousel is actually on screen, as the smaller of its two
       axes rather than the area ratio the observer reports. Area alone is the
       wrong measure here: on a phone the row is a 9:16 card tall and can be
       taller than the screen it is on, so it would never reach a high ratio
       however squarely it is being looked at. Measuring each axis against the
       smaller of the element and the viewport makes "half showing" mean the
       same thing either way. */
    const visibleShare = (entry) => {
      const box = entry.boundingClientRect;
      const seen = entry.intersectionRect;
      const height = Math.min(box.height, innerHeight) || 1;
      const width = Math.min(box.width, innerWidth) || 1;
      return Math.min(seen.height / height, seen.width / width);
    };

    /* The card that counts as in view is the carousel's own centred card, the
       one it already marks and already scales up. Asking the observer that
       question instead - a centre band for a root, say - gets it wrong at both
       ends of the row, because the row rests flush on its first card rather
       than centring it, so at rest the middle of the track is over the second
       card while the first is the one on show. The carousel clamps for that;
       nothing measured against the track's midpoint can.

       Before the carousel has painted there is no marked card, and the first
       one is the answer rather than a guess: that is where the row rests. */
    const inView = (carousel) =>
      carousel.querySelector('.ucard.is-active') || carousel.querySelector('.ucard');

    /* Exactly one clip runs per carousel: the card in view plays, every other
       one pauses and rewinds. That is what keeps `preload="none"` meaningful -
       a card that is never the one in view never costs a byte - and it keeps
       four muted videos from decoding at once on a desktop row. */
    const evaluate = (carousel) => {
      const focus = onScreen.get(carousel) ? inView(carousel) : null;

      carousel.querySelectorAll('.ucard').forEach((card) => {
        const video = card.querySelector('.ucard__video');
        if (!video) return;

        if (card !== focus) {
          if (!video.paused) stop(card, video, true);
          return;
        }

        /* The card in view starts itself unless motion is unwelcome, or it was
           paused by hand - that is a decision, and scrolling it away and back
           is not a request to undo it. Pressing the button is, and that is what
           clears the flag. Nothing here stops the card in view, so a clip
           started by hand keeps running even where autoplay would not have. */
        if (video.paused && !reduce.matches && card.dataset.ugcPaused !== 'true') {
          play(card, video);
        }
      });
    };

    /* One observer per carousel, answering only "is this row on the page in
       front of somebody" - which card is in view is the carousel's business,
       above. A row scrolled off the page plays nothing at all. */
    const watcher =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                onScreen.set(entry.target, visibleShare(entry) >= 0.5);
                evaluate(entry.target);
              });
            },
            { threshold: [0, 0.25, 0.5, 0.75, 1] }
          )
        : null;

    const wireCard = (card) => {
      if (card.dataset.ugcBound) return;
      card.dataset.ugcBound = 'true';

      const video = card.querySelector('.ucard__video');
      if (!video) return;

      const button = card.querySelector('[data-ugc-toggle]');
      if (!button) return;

      button.addEventListener('click', () => {
        const carousel = card.closest('[data-ugc-carousel]');

        if (video.paused) {
          /* Started by hand, so it takes the slot: one clip at a time holds
             however playback was asked for. */
          delete card.dataset.ugcPaused;
          if (carousel) {
            carousel.querySelectorAll('.ucard').forEach((other) => {
              if (other === card) return;
              const clip = other.querySelector('.ucard__video');
              if (clip && !clip.paused) stop(other, clip, true);
            });
          }
          play(card, video);
        } else {
          card.dataset.ugcPaused = 'true';
          stop(card, video, false);
        }
      });
    };

    /* The carousel says when the card in view changes; this only has to ask
       again when it does. */
    const wireCarousel = (carousel) => {
      if (carousel.dataset.ugcPlaybackBound) return;
      carousel.dataset.ugcPlaybackBound = 'true';

      carousel.addEventListener('ugc:active', () => evaluate(carousel));

      /* Without an observer there is no page visibility to read, so the row
         counts as on screen and the card in view still plays. */
      if (watcher) {
        watcher.observe(carousel);
      } else {
        onScreen.set(carousel, true);
      }

      evaluate(carousel);
    };

    /* This IIFE owns playback only; the carousel below owns movement. */
    const init = () => {
      document.querySelectorAll('.ucard').forEach(wireCard);
      document.querySelectorAll('[data-ugc-carousel]').forEach(wireCarousel);
    };

    init();
    document.addEventListener('shopify:section:load', init);
  })();

  /*
    Centred carousel.

    The track does the scrolling itself, so swipe, momentum, snapping and the
    focus ring are the browser's. This only answers one question - which card is
    nearest the middle - and moves the scroll position when something asks for
    the next one.
  */
  (() => {
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');

    const wireCarousel = (carousel) => {
      if (carousel.dataset.ugcCarouselBound) return;
      carousel.dataset.ugcCarouselBound = 'true';

      const track = carousel.querySelector('.ucar__track');
      if (!track) return;

      const prev = carousel.querySelector('[data-ugc-prev]');
      const next = carousel.querySelector('[data-ugc-next]');
      const cards = () => Array.from(track.querySelectorAll('.ucard'));

      /* Outside the range to start with, so the first paint always announces a
         card rather than looking like it never changed from one. */
      let active = -1;
      /* Where a smooth scroll is heading, so two quick presses advance twice
         rather than both measuring the same half finished position. */
      let target = null;

      /* Where the scroller has to sit for this card to be the centred one, with
         the ends clamped into range. Measured off offsetLeft rather than rects
         because the cards are scaled and rotated: those are layout numbers and
         ignore the transform, which is exactly what a snap position wants.

         Clamping is what makes the first card the one showing at rest. Its
         ideal position is negative, the scroller cannot go there, so it clamps
         to 0 - the same place the row actually starts. */
      const snapTargetOf = (card) => {
        const limit = track.scrollWidth - track.clientWidth;
        const middle = card.offsetLeft + card.offsetWidth / 2 - track.clientWidth / 2;
        return Math.max(0, Math.min(middle, limit));
      };

      /* Nearest snap position, not nearest to the middle of the viewport. At
         either end no card sits in the middle, and asking which one is closest
         to it there picks whichever happens to be second - so the row would
         open with its second clip enlarged and the first one dimmed beside it. */
      const nearest = () => {
        let best = 0;
        let bestGap = Infinity;
        cards().forEach((card, i) => {
          const gap = Math.abs(snapTargetOf(card) - track.scrollLeft);
          if (gap < bestGap) {
            bestGap = gap;
            best = i;
          }
        });
        return best;
      };

      const paint = () => {
        const list = cards();
        const previous = active;
        active = nearest();
        if (target === active) target = null;

        list.forEach((card, i) => {
          card.classList.toggle('is-active', i === active);
          card.classList.toggle('is-prev', i === active - 1);
          card.classList.toggle('is-next', i === active + 1);
        });

        if (prev) prev.disabled = active <= 0;
        if (next) next.disabled = active >= list.length - 1;

        /* Movement's one word to playback: the card in view changed. Sent on
           the change rather than on the scroll, so a swipe across the row is
           one message per card and not one per frame. */
        if (active !== previous) carousel.dispatchEvent(new CustomEvent('ugc:active'));
      };

      const goTo = (index) => {
        const list = cards();
        const clamped = Math.max(0, Math.min(index, list.length - 1));
        const card = list[clamped];
        if (!card) return;
        target = clamped;
        track.scrollTo({
          left: snapTargetOf(card),
          behavior: reduce.matches ? 'auto' : 'smooth',
        });
      };

      const step = (delta) => goTo((target === null ? active : target) + delta);

      let ticking = false;
      track.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            paint();
            ticking = false;
          });
        },
        { passive: true }
      );

      if (prev) prev.addEventListener('click', () => step(-1));
      if (next) next.addEventListener('click', () => step(1));

      /* The track stays the focusable region it was as a rail, and keeps the
         same contract: left and right move it one card, not one nudge. */
      track.addEventListener('keydown', (event) => {
        const keys = {
          ArrowRight: () => step(1),
          ArrowLeft: () => step(-1),
          Home: () => goTo(0),
          End: () => goTo(cards().length - 1),
        };
        const run = keys[event.key];
        if (!run) return;
        event.preventDefault();
        run();
      });

      /* The end padding is a percentage of the track, so a resize moves every
         snap point and the centred card has to be found again. */
      addEventListener('resize', paint, { passive: true });

      paint();
    };

    const initCarousel = () => document.querySelectorAll('[data-ugc-carousel]').forEach(wireCarousel);

    initCarousel();
    document.addEventListener('shopify:section:load', initCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
